var React = require('react');

function IconmonstrArrow24OutlineRt (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFFFFF;}\n"),React.createElement("g",{"key":1},[React.createElement("polygon",{"className":"st0","points":"5.9,0 0,5.7 8,13.7 0,21.8 5.9,27.5 19.5,13.7 \t","key":0}),React.createElement("path",{"d":"M5.9,25.7l-4.1-4l8-8l-8-8l4.1-4l11.9,12L5.9,25.7z","key":1})])]);
}

IconmonstrArrow24OutlineRt.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 19.5 27.5","style":{"enableBackground":"new 0 0 19.5 27.5"},"xmlSpace":"preserve"};

module.exports = IconmonstrArrow24OutlineRt;

IconmonstrArrow24OutlineRt.default = IconmonstrArrow24OutlineRt;
